
export const MaximalLayoutConfig = {
	favicon: '/assets/retailer.ico',
	icon: '/assets/retailer_ico.svg',
	emptyImage: '/assets/images/empty_content.svg',
	appName: '',
	header: {
		height: 51,
		hidden: false
	},
	menu: {
		size: 'extended',
		spacing: 8,
		width: {
			desktop: 92,
			mobile: 64
		},
		nav: {
			width: {
				extended: 280,
				mini: 88
			},
			height: {
				item: 48,
				subItem: 36
			}
		}
	}
}

